module.exports = __webpack_public_path__ + "img/espaco2.375f2af6.jpg";